/**
 * @param {Date} from
 * @param {Date} to
 * @returns {number}
 */
function calculateDaysCount(from, to) {
  if (!(from instanceof Date)) {
    throw new Error('Parameter from must instance of Date');
  }

  if (!(to instanceof Date)) {
    throw new Error('Parameter to must instance of Date');
  }

  const fromDate = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  const toDate = new Date(to.getFullYear(), to.getMonth(), to.getDate());
  const diff = (fromDate.getTime() - toDate.getTime()) / (1000 * 60 * 60 * 24);

  return Math.round(Math.abs(diff)) + 1;
}

export default calculateDaysCount;
